export function loader() {
  const preloader = document.querySelector(".loader-block");

  if (!preloader) return;

  Promise.all([
    waitForImages(),
    waitForBackgroundImages(),
    new Promise((resolve) => setTimeout(resolve, 1000)),
  ]).then(() => {
    preloader.classList.add("loader-block--hidden");

    setTimeout(() => {
      preloader.remove();
    }, 500);
  });
}

function waitForImages() {
  const images = document.querySelectorAll("img");
  const imagePromises = Array.from(images).map((img) => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.addEventListener("load", resolve);
      img.addEventListener("error", resolve);
    });
  });
  return Promise.all(imagePromises);
}

function waitForBackgroundImages() {
  const elements = document.querySelectorAll("*");
  const bgPromises = [];

  elements.forEach((element) => {
    const style = window.getComputedStyle(element);
    const bgImage = style.backgroundImage;

    // Проверяем, есть ли background-image и это не градиент
    if (bgImage && bgImage !== "none" && !bgImage.includes("gradient")) {
      // Извлекаем URL из background-image
      const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
      if (match && match[1]) {
        const imgUrl = match[1];
        bgPromises.push(loadBackgroundImage(imgUrl));
      }
    }
  });

  return Promise.all(bgPromises);
}

function loadBackgroundImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = url;
  });
}
